import React, {useCallback, useLayoutEffect, useRef} from 'react'
import {findDOMNode} from "react-dom"

import {InternalLinkOption} from "../../option"
import VScroll from "../../../../../scrolling/custom-v-scroll/v-scroll"
import {PopoverMenuItemType} from "../../../../../popover-menu/popover-menu/const"
import PopoverMenuHeader from "../../../../../popover-menu/popover-menu/popover-menu-header"
import PopoverMenuSeparator from "../../../../../popover-menu/popover-menu/popover-menu-separator"
import PopoverMenuOptionWithSubmenu from "../../../../../popover-menu/popover-menu/option-with-submenu/menu-option-with-submenu"
import PopoverMenuOption from "../../../../../popover-menu/popover-menu/menu-option"

type Props = {
    selectedIndex   : number | null
    options         : InternalLinkOption[]

    onClick         : {(index:number, option:InternalLinkOption): void}
}

const debug = false
// const debug = "SlashSearchMenu"

export default function SlashSearchMenu (props: Props) {
    const scrollRef: any            = useRef()

    const getScrollContainerNode = useCallback(() => {
        return findDOMNode(scrollRef.current)?.childNodes[1]
    }, [scrollRef.current])

    const setScrollTop    = useCallback((scrollValue: any) => {
        if (!_.isNil(scrollValue)) {
            scrollRef.current?.setScrollTop(scrollValue, false, 100)
        }
    }, [scrollRef.current])

    const selectedId = props.selectedIndex ? props.options[props.selectedIndex]?.id : undefined

    useLayoutEffect(() => {
        const scrollContainerNode   : any   = getScrollContainerNode()
        const selectedNode          : any   = selectedId ? document.getElementById(selectedId) : null

        if (selectedNode && scrollContainerNode) {
            const selectedOptionTop     = selectedNode.offsetTop
            const selectedOptionBottom  = selectedNode.offsetTop + selectedNode.clientHeight
            const scrollTop             = scrollContainerNode.scrollTop
            const scrollBottom          = scrollContainerNode.scrollTop + scrollContainerNode.clientHeight

            // set scroll value if selected option is outside scroll visible area
            let scrollValue
            if (selectedOptionTop < scrollTop) {
                scrollValue = selectedOptionTop
            } else if (selectedOptionBottom > scrollBottom) {
                scrollValue = selectedOptionBottom - scrollContainerNode.clientHeight
            }

            setScrollTop(scrollValue)
        }
    }, [props.selectedIndex])

    const lastItemKey = props.options.length - 1

    return (
        <div className="ui5-popover-menu">
            <VScroll ref={scrollRef} containerStyle={{width:180, maxHeight:250}}>
                {_.map(props.options, (option:InternalLinkOption, key:number) => {
                    const isHighlighted = key === props.selectedIndex
                    const isLast        = key === lastItemKey

                    if (option.type === PopoverMenuItemType.HEADER) {
                        return <PopoverMenuHeader key={key} title={option.label}/>
                    }

                    if (option.type === PopoverMenuItemType.SEPARATOR) {
                        if (isLast) return null
                        return <PopoverMenuSeparator key={key}/>
                    }

                    if (option.type === PopoverMenuItemType.SUBMENU) {
                        return <PopoverMenuOptionWithSubmenu key                = {key}
                                                             id                 = {option.id}
                                                             option             = {option as any}
                                                             isHighlighted      = {isHighlighted}
                                                             showMenuSelection  = {false}
                                                             onClick            = {(value: any, subOption: any)=>props.onClick(key, subOption)}/>
                    }

                    return <PopoverMenuOption key           = {key}
                                              id            = {option.id}
                                              option        = {option as any}
                                              isHighlighted = {isHighlighted}
                                              onClick       = {()=>props.onClick(key, option)}/>
                })}
            </VScroll>
        </div>
    )
}
